export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-navy text-white pt-20 lg:pt-24 pb-10 overflow-hidden">
      <div className="absolute top-0 left-1/3 h-72 w-72 rounded-full bg-blue-500/10 blur-3xl pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
          <div className="col-span-2">
            <a href="#top" className="inline-flex items-center">
              <img
                src="/fyzeron-logo-white.png"
                alt="Fyzeron Technologies LLP"
                className="h-11 w-auto"
              />
            </a>
            <p className="mt-5 text-sm text-blue-100/70 max-w-sm leading-relaxed">
              Makers of <span className="font-semibold text-white">FolioStax</span> — a powerful, easy-to-use
              billing app for cafes, restaurants, grocery stores, supermarkets, retail shops
              and more.
            </p>
          </div>

          <FooterCol title="Product" links={[
            { l: "Features", h: "#features" },
            { l: "Business Types", h: "#industries" },
            { l: "Pricing", h: "#pricing" },
          ]} />
          <FooterCol title="Company" links={[
            { l: "About Us", h: "#about" },
            { l: "Support", h: "#contact" },
            { l: "Terms & Conditions", h: "/foliostax/terms" },
            { l: "Privacy Policy", h: "/foliostax/privacy-policy" },
            { l: "Delete Account", h: "/foliostax/delete-account" },
          ]} />
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-blue-200/60">
          <p>© {new Date().getFullYear()} Fyzeron Technologies LLP. All rights reserved.</p>
          <p>Made with care in India</p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <p className="font-display font-bold text-sm tracking-wide">{title}</p>
      <ul className="mt-4 space-y-2">
        {links.map((l) => (
          <li key={l.l}>
            <a href={l.h} className="text-sm text-blue-100/70 hover:text-white transition">
              {l.l}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
